import { render, staticRenderFns } from "./OnlineOrders.vue?vue&type=template&id=ccee8bf4"
import script from "./OnlineOrders.vue?vue&type=script&lang=js"
export * from "./OnlineOrders.vue?vue&type=script&lang=js"
import style0 from "./OnlineOrders.vue?vue&type=style&index=0&id=ccee8bf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports